import { render, staticRenderFns } from "./mdc-overline.vue?vue&type=template&id=1d3a3142&"
import script from "./mdc-overline.vue?vue&type=script&lang=ts&"
export * from "./mdc-overline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports